export interface NiceAxis {
  min: number
  max: number
  step: number
}

/** 1, 2, 2.5 or 5 times a power of ten — the smallest of them not below `raw`. */
function niceStep(raw: number): number {
  const power = 10 ** Math.floor(Math.log10(raw))

  return (
    [1, 2, 2.5, 5, 10].map((m) => m * power).find((step) => step >= raw) ??
    10 * power
  )
}

/**
 * An axis over `low`…`high` cut into exactly `steps` round steps — so several axes built
 * with the same `steps` share their gridlines, which is what amCharts' `syncWithAxis` gives
 * and Chart.js has no option for. A flat line — a one-day report — gets a tenth of its
 * value either side, so its point sits inside the chart rather than on the axis.
 */
export function niceAxis(low: number, high: number, steps: number): NiceAxis {
  const room = high > low ? 0 : Math.abs(low) * 0.1 || 1
  const bottom = low === 0 ? 0 : low - room
  const top = high + room
  let step = niceStep((top - bottom) / steps)

  for (;;) {
    const min = Math.floor(bottom / step) * step

    if (min + step * steps >= top) return { min, max: min + step * steps, step }

    step = niceStep(step * 1.0001)
  }
}
